import * as Ajax from "js/common/ajax";
import Immutable from "immutable";

export const loadTargets = (kpiId, params) => Ajax
    .get({
      url: `/kpi/${kpiId}/qualifierTargets`,
      data: params
    })
    .then(targets => Immutable.fromJS(targets));

export const updateTargets = (kpiId, targets, source) => Ajax
    .put({
      url: `/kpi/${kpiId}/targets?source=${source}`,
      json: targets
    })
    .then(targets => Immutable.fromJS(targets));

export const addTargetNote = (targetId, note, source) => Ajax
    .post({
      url: `kpi/target/${targetId}/note?source=${source}`,
      json: {note}
    })
    .then(targetNoteAssignments => Immutable.fromJS(targetNoteAssignments));
